<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <div class="d-print-none">
      <div class="float-end">
        <a href="javascript:window.print()"
          class="btn btn-primary waves-effect waves-light me-1"
          ><i class="fa fa-print"></i> Print Report</a>

        <!-- <b-button @click="sendReportEmail" class="me-1">
            <i class="fas fa-envelope"></i> Email Report
            <b-spinner v-if="isLoadingmail" small label="Small Spinner"></b-spinner>
        </b-button>

          <b-button variant="success" @click="sendWhatsApp">
              <i class="fab fa-whatsapp"></i> Send Report
              <b-spinner v-if="isLoadingmessage" small label="Small Spinner"></b-spinner>
          </b-button> -->
      </div>


      <!-- END EMAIL MODEL -->
    </div>
    <div class="d-print-none">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row print">
      <div class="col-12">
        <div class="card p-2">
          <div class="card-body">
            <div>
              <div style="width: 100%; top: 0px; height: 130px">
                <div style="width: 50%; float: left; top: 0px">
                  <img :src="AllResults[0].clinic_logo" alt="Logo" height="100" />
                </div>
                <div style="width: 50%; float: right; top: 0px">
                  <h3 class="text-uppercase text-end">
                    <strong>{{ AllResults[0].clinic_name }}</strong>
                  </h3>
                  <table align="right" width="100%">
                    <tr align="right">
                      <td v-html="AllResults[0].clinic_address"></td>
                    </tr>
                    <tr align="right">
                      <td>
                        <strong>Tel:</strong>
                        +{{ AllResults[0].clinic_contact }}
                      </td>
                    </tr>
                    <tr align="right">
                      <td>
                        <strong>Email:</strong>
                        {{ AllResults[0].clinic_email }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <hr />
              <div style="text-align: center">
                <h4 class="text-decoration-underline">
                  <strong>FINAL LABORATORY REPORT</strong>
                </h4>
              </div>
              <!--              <hr/>-->
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Patient Name:</td>
                    <td>
                      <b>{{ AllResults[0].patient_name }}</b>
                    </td>
                    <td>Patient Id:</td>
                    <td>
                      <b>{{ AllResults[0].patient_code }}</b>
                    </td>
                  </tr>
                  <tr v-show="AllResults[0].age || AllResults[0].gender">
                    <td v-show="AllResults[0].gender">Gender</td>
                    <td v-show="AllResults[0].gender">
                      <b v-if="AllResults[0].gender == 1">Male</b>
                      <b v-else>Female</b>
                    </td>
                    <td v-show="AllResults[0].age">Age:</td>
                    <td v-show="AllResults[0].age">
                      <b>{{ AllResults[0].age }} </b>
                      <span v-if="AllResults[0].age_unit == 1">Years</span>
                      <span v-else-if="AllResults[0].age_unit == 2">Months</span>
                      <span v-else-if="AllResults[0].age_unit == 3">Days</span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                  <tr
                    v-show="
                      AllResults[0].patient_village || AllResults[0].patient_contact
                    "
                  >
                    <td v-show="AllResults[0].patient_contact">Patient Contact:</td>
                    <td v-show="AllResults[0].patient_contact">
                      <b>{{ AllResults[0].patient_contact }}</b>
                    </td>
                    <td v-show="AllResults[0].patient_village">Patient's Village:</td>
                    <td v-show="AllResults[0].patient_village">
                      <b>{{ AllResults[0].patient_village }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td v-show="AllResults[0].temperature">Temperature:</td>
                    <td v-show="AllResults[0].temperature">
                      <b>{{ AllResults[0].temperature }} &#8451;</b>
                    </td>
                    <td v-show="AllResults[0].pressure">Pressure:</td>
                    <td v-show="AllResults[0].pressure">
                      <b>{{ AllResults[0].pressure }} mmHg</b>
                    </td>
                  </tr>
                  <tr>
                      <td v-show="AllResults[0].weight">Weight:</td>
                      <td v-show="AllResults[0].weight">
                          <b>{{ AllResults[0].weight }} KG</b>
                      </td>
                      <td v-show="AllResults[0].height">Height:</td>
                      <td v-show="AllResults[0].height">
                          <b>{{ AllResults[0].height }} CM</b>
                      </td>
                  </tr>
                  <tr>
                    <td>Facility:</td>
                    <td>
                      <b>{{ AllResults[0].facility }}</b>
                    </td>
                    <td>Print Date:</td>
                    <td>
                      <b>{{ AllResults[0].print_date }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--              <hr v-show="AllResults[0].samples.length"/>-->
              <h5
                v-show="AllResults[0].samples.length"
                style="
                  text-decoration: underline;
                  text-transform: uppercase;
                  font-weight: bold;
                "
              >
                Test Samples
              </h5>
              <table width="100%" v-show="AllResults[0].samples.length">
                <thead>
                  <th>Sample Type</th>
                  <th>Date Collected</th>
                  <th>Date Received</th>
                  <th>Test Requested</th>
                </thead>
                <tr v-for="(sample, s) in AllResults[0].samples" :key="s">
                  <td>{{ sample.sample_name }}</td>
                  <td>{{ sample.pick_time }}</td>
                  <td>{{ sample.receive_time }}</td>
                  <td>{{ sample.test_name }}</td>
                </tr>
              </table>
              <!--              <hr v-show="AllResults[0].complete_tests.length"/>-->
              <h5
                v-show="AllResults[0].complete_tests.length"
                style="
                  text-decoration: underline;
                  text-transform: uppercase;
                  font-weight: bold;
                "
              >
                Test Results
              </h5>
              <div v-for="(test, t) in AllResults[0].complete_tests" :key="t">
                <table width="100%" v-if="test.result_type == 1">
                  <thead width="100%">
                    <th width="50%">Test Done</th>
                    <th width="50%">Result</th>
                  </thead>
                  <tbody>
                    <tr width="100%">
                      <td width="50%">{{ test.test_name }}</td>
                      <td width="50%">
                        <span v-if="test.complete_results.length">
                          {{ test.complete_results[0].option_name }}
                        </span>
                        <span v-else> _ _ _ _ </span>
                      </td>
                    </tr>
                    <tr>
                      <td width="100%" colspan="2">
                        <p>comment: {{ test.comment }}</p>
                        <span
                          ><br />
                          <p>
                            Performed By:
                            <strong>{{ test.technician }}</strong>
                            Result Entry Date:
                            <strong>{{ test.result_date }}</strong>
                          </p>
                          <p v-if="test.reviewer">
                            Reviewed By:
                            <strong>{{ test.reviewer }}</strong>
                            Date Reviewed:
                            <strong>{{ test.review_date }}</strong>
                          </p>
                        </span>
                        <!--                      <hr/>-->
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table width="100%" v-if="test.result_type == 2">
                  <thead width="100%">
                    <th width="50%">Test Done</th>
                    <th width="50%">Comment</th>
                  </thead>
                  <tbody>
                    <tr width="100%">
                      <td width="50%">{{ test.test_name }}</td>
                      <td width="50%">{{ test.comment }}</td>
                    </tr>
                    <tr>
                      <td width="100%" colspan="2">
                        <span
                          ><br />
                          <p>
                            Performed By:
                            <strong>{{ test.technician }}</strong>
                            Result Entry Date:
                            <strong>{{ test.result_date }}</strong>
                          </p>
                          <p v-if="test.reviewer">
                            Reviewed By:
                            <strong>{{ test.reviewer }}</strong>
                            Date Reviewed:
                            <strong>{{ test.review_date }}</strong>
                          </p>
                        </span>
                        <!--                      <hr/>-->
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table width="100%" v-if="test.result_type == 3">
                  <thead width="100%">
                    <th width="50%">Test Done</th>
                    <th width="50%">comment</th>
                  </thead>
                  <tbody>
                    <tr width="100%">
                      <td width="50%">{{ test.test_name }}</td>
                      <td width="50%">{{ test.comment }}</td>
                    </tr>
                    <tr>
                      <td width="100%" colspan="2">
                        <span
                          ><br />
                          <p>
                            Performed By:
                            <strong>{{ test.technician }}</strong>
                            Result Entry Date:
                            <strong>{{ test.result_date }}</strong>
                          </p>
                          <p v-if="test.reviewer">
                            Reviewed By:
                            <strong>{{ test.reviewer }}</strong>
                            Date Reviewed:
                            <strong>{{ test.review_date }}</strong>
                          </p>
                        </span>
                        <!--                      <hr/>-->
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table width="95%" v-if="test.result_type == 4">
                  <thead>
                    <th>Test Done</th>
                    <th>
                      <table width="100%">
                        <thead>
                          <th width="20%">Parameters</th>
                          <th width="10%">Result</th>
                          <th width="10%">Flag</th>
                          <th width="10%">Range</th>
                          <th width="10%">SI Unit</th>
                        </thead>
                      </table>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ test.test_name }}</td>
                      <td>
                        <table
                          width="100%"
                          class="table"
                          v-if="test.complete_results.length"
                        >
                          <tr
                            v-for="(complete_result, c) in test.complete_results"
                            :key="c"
                          >
                            <td width="20%">{{ complete_result.option_name }}</td>
                            <td width="10%">{{ complete_result.result_value }}</td>
                            <td width="10%">{{ complete_result.flag }}</td>
                            <td width="10%" v-html="complete_result.range"></td>
                            <td width="10%">{{ complete_result.unit }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <span>
                          <p>
                            Performed By:
                            <strong>{{ test.technician }}</strong>
                            Result Entry Date:
                            <strong>{{ test.result_date }}</strong>
                          </p>
                          <p v-if="test.reviewer">
                            Reviewed By:
                            <strong>{{ test.reviewer }}</strong>
                            Date Reviewed:
                            <strong>{{ test.review_date }}</strong>
                          </p>
                        </span>
                        <!--                      <hr/>-->
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table class="table" v-if="test.result_type == 5">
                  <caption>
                    {{
                      test.test_name
                    }}
                    Test
                  </caption>
                  <thead>
                    <th>Organism(s) Isolated</th>
                    <th>
                      <table width="100%">
                        <thead>
                          <th width="40%">Antibiotic(s)</th>
                          <th width="30%">Zone diameter</th>
                          <th width="30%">Result(s)</th>
                        </thead>
                      </table>
                    </th>
                  </thead>
                  <tbody v-if="test.complete_results.length">
                    <tr v-for="(organism, organ) in test.complete_results" :key="organ">
                      <td>{{ organism.option_name }}</td>
                      <td>
                        <table width="100%">
                          <tr v-for="(antibio, ant) in organism.result_codes" :key="ant">
                            <td width="40%">{{ antibio.antibiotic }}</td>
                            <td width="30%">{{ antibio.zone }}</td>
                            <td width="30%">{{ antibio.result }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <span
                          ><br />
                          <p>
                            Performed By:
                            <strong>{{ test.technician }}</strong>
                            Result Entry Date:
                            <strong>{{ test.result_date }}</strong>
                          </p>
                          <p v-if="test.reviewer">
                            Reviewed By:
                            <strong>{{ test.reviewer }}</strong>
                            Date Reviewed:
                            <strong>{{ test.review_date }}</strong>
                          </p>
                        </span>
                        <!-- <hr/>-->
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="text-align: center" v-if="AllResults[0].branding_settings == 1">
                <p style="font-size: 10px">
                  Report Printed by {{ AllResults[0].printuser }} via Clinic Plus Hospital
                  Software
                </p>
              </div>
              <div class="image" v-if="AllResults[0].clinic_stamp">
                <img :src="AllResults[0].clinic_stamp" alt="stamp" />
                <div class="stamp_date">{{ AllResults[0].date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Results Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      send_emails: {
        email: "",
        visit_id: this.$route.params.visit,
      },

      title: "Laboratory Results",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Results Report",
          active: true,
        },
      ],
      toPrint: this.$route.params,
      showstamp: true,
        isLoadingmail: false,
        isLoadingmessage: false
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("reports", ["AllResults"]),
  },

  methods: {
    ...mapActions({
      FetchResult: "reports/fetchAllResults",
      EmailAllResult: "reports/emailAllResult",
    }),
    sendReportEmail() {
      this.isLoadingmail = true
      axios.get(`email_all_report/${this.$route.params.visit}`)
        .then((response) => {
          this.isLoadingmail = false;
          alert(response.data.message);
        })
        .catch((error) => {
          this.isLoadingmail = false;
          alert('Something wrong happened. Messages was not sent')
          console.log(error);// eslint-disable-line no-console
        });
    },
   
    
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END VALIDATION

      sendWhatsApp(){
        this.isLoadingmessage = true
          let phone = '256702634754';
        let message = 'Download your results here: https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf, Thank'
          setTimeout(function () {
              window.open(
                  `whatsapp://send?abid=/${phone}&text=${message}`
              );
          }, 3000);
      }
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.closeMode(this.model_id);
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },

  created() {
    this.FetchResult(this.toPrint);
  },
};
</script>

<style lang="css" scoped>
.image {
  left: 100vw;
}
.image img {
  width: 180px;
}

.stamp_date {
  position: relative;
  color: red !important;
  font-size: 18px !important;
  top: -68px;
  font-weight: bold;
  left: 5%;
}

.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
hr {
  height: 1px;
  border-width: 0;
  color: gray;
  background-color: gray;
}
</style>
